import React from 'react';

export const ReportingToolIcon = (tileicons: { [key: string]: string } | undefined, reportingToolName: string) => {
    if (undefined === tileicons || undefined === tileicons[reportingToolName] || '' == tileicons[reportingToolName])
        return null;

    const style = {
        width: '14px',
        height: '14px',
        marginRight: '8px',
    };

    return <img src={tileicons[reportingToolName]} style={style} />;
};
